import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import Form from 'Components/Form'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { Input } from 'Components/Form/Input'
import SubmitButton from 'Components/Form/SubmitButton'
import Button from 'Components/Form/Button'
import { required } from 'Utils/Validators/formValidation'
import { TAGS_MANAGEMENT_FORM_MODES } from '../const'
import { TAG_TYPE_ENUM } from '../../../../shared/constants'
import { styles } from './styles'

const TagsManagementForm = ({
  classes,
  defaultValues,
  mode,
  handleCancel,
  handleSubmit,
  buttonsDisabled,
}) => (
  <Form onSubmit={handleSubmit}>
    <Typography className={classes.title} variant="h4">
      {mode === TAGS_MANAGEMENT_FORM_MODES.CREATE ? 'Create Tags' : 'Edit Tags'}
    </Typography>
    <Card className={classes.card}>
      <Input
        className={classes.input}
        label="Name"
        name="name"
        validator={[required]}
        initValue={
          mode === TAGS_MANAGEMENT_FORM_MODES.EDIT ? defaultValues.value : ''
        }
      />
      <SelectDashboard
        label="Type"
        name="type"
        options={Object.keys(TAG_TYPE_ENUM).map(item => ({
          label: item,
          value: item,
        }))}
        validator={[required]}
        initValue={
          mode === TAGS_MANAGEMENT_FORM_MODES.EDIT
            ? defaultValues.type
            : TAG_TYPE_ENUM.CLIENT
        }
      />
    </Card>
    <div className={classes.buttonsWrapper}>
      <Button variant="outlined" value="Cancel" onClick={handleCancel} />
      <SubmitButton
        disabled={buttonsDisabled}
        variant="contained"
        value="Submit"
      />
    </div>
  </Form>
)

export default withStyles(styles)(TagsManagementForm)



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/TagsManagementForm/index.js